import { Component, inject, OnInit } from '@angular/core';
import { FileStore } from '../../../stores/file.store';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-expired',
  imports: [CommonModule],
  templateUrl: './expired.component.html',
  styleUrl: './expired.component.scss'
})
export class ExpiredComponent implements OnInit {
  displayExpirationDate = '';
  expirationDate: Date | undefined;
  private _fileStore = inject(FileStore);
  ngOnInit(): void {
    const expirationDate = this._fileStore.getFileSignatureInfo()?.expirationDate || undefined;
    if (expirationDate) {
      const date = new Date(expirationDate);
      this.displayExpirationDate = date.toLocaleString();
    } else {
      this.displayExpirationDate = '';
    }
  }
}
